import { Button, HStack, Text, WhiteCard } from '@elkaso-app/web-design';
import { useUpdateInvoiceScanStatusApi } from 'apis/invoice-scanning';
import { useQueryClient } from 'react-query';
import { validationStatusLabels, ValidationStatus } from '../utils/invoice-scan-status';
import { getAvailableTransitions } from '../utils/validation-transitions';

interface ValidationActionsProps {
  scanId: number;
  currentStatus: string;
}

const buttonColorSchemes: Record<string, string> = {
  valid: 'green',
  invalid: 'red',
  partial_match: 'orange',
  order_mismatch: 'red',
  pending: 'gray',
};

export const ValidationActions = ({ scanId, currentStatus }: ValidationActionsProps) => {
  const queryClient = useQueryClient();
  const { mutate: updateStatus, isLoading } = useUpdateInvoiceScanStatusApi({
    onSuccess: () => {
      queryClient.invalidateQueries([`ums/v1/cms/invoice-scanning/scans/${scanId}`]);
    },
  });

  const availableTransitions = getAvailableTransitions(currentStatus);

  if (availableTransitions.length === 0) {
    return (
      <WhiteCard p='lg'>
        <Text fontSize='sm' color='gray.500'>
          Validation status is{' '}
          <strong>{validationStatusLabels[currentStatus as ValidationStatus] || currentStatus}</strong> (terminal state
          — no further transitions).
        </Text>
      </WhiteCard>
    );
  }

  return (
    <WhiteCard p='lg'>
      <Text fontSize='sm' color='gray.500' mb='md'>
        Update Validation Status:
      </Text>
      <HStack spacing='sm' flexWrap='wrap'>
        {availableTransitions.map((status) => (
          <Button
            key={status}
            size='sm'
            variant='outline'
            colorScheme={buttonColorSchemes[status] || 'gray'}
            onClick={() => updateStatus({ scanId, validationStatus: status })}
            isLoading={isLoading}
            isDisabled={isLoading}>
            {status === 'pending' ? 'Reset to Pending' : validationStatusLabels[status]}
          </Button>
        ))}
      </HStack>
    </WhiteCard>
  );
};
